import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import {Gateway} from "./Gateway";
import CoreContainer from "./core/CoreContainer";
import 'react-image-lightbox/style.css';

ReactDOM.render(<Gateway coreContainer={CoreContainer} />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
